export default "__VITE_PUBLIC_ASSET__6fd52f6b__"